import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { VodafoneGeneralReportFilter } from '../models/model'

export class GetVodafoneGeneralReportFilterApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/vodafoneDealer/getVodafoneGeneralReportFilter',
      requesterInfo,
    })
  }

  public async getPKIMEIData(): Promise<VodafoneGeneralReportFilter> {
    return await this.getAsync<VodafoneGeneralReportFilter>()
  }
}
